import React from "react";
import LegalLayout from "../../layouts/LegalLayout/LegalLayout";
import styles from "./Legal.module.scss";

const ESignConsent = () => {
  return (
    <LegalLayout title="STBL E-SIGN CONSENT">
      <div className={styles.legalContent}>
        <section className={styles.section}>
          <h3>STBL Electronic Communications &amp; E-Sign Consent</h3>
          <p>
            <strong>Effective Date:</strong> 5/13/2026
          </p>
          <p>
            This Electronic Communications and E-Sign Consent (&ldquo;Consent&rdquo;)
            allows STBL, LLC (&ldquo;STBL,&rdquo; &ldquo;we,&rdquo; &ldquo;our,&rdquo;
            or &ldquo;us&rdquo;) to provide you with disclosures, notices, agreements,
            statements, and other communications electronically.
          </p>
          <p>
            By checking the box indicating your acceptance of this Consent, creating
            an account, applying for an STBL Card, or otherwise using STBL services,
            you:
          </p>
          <ul>
            <li>consent to receive electronic communications from STBL;</li>
            <li>agree to transact electronically with STBL;</li>
            <li>
              acknowledge that your electronic signature is legally binding; and
            </li>
            <li>confirm that you can access and retain electronic records.</li>
          </ul>
          <p>
            This Consent applies to all communications related to your use of the
            STBL platform and any associated products or services.
          </p>

          <h3>1. Scope of Communications</h3>
          <p>
            You agree that STBL may provide any communications to you electronically,
            including but not limited to:
          </p>
          <ul>
            <li>Terms and conditions</li>
            <li>Privacy policies</li>
            <li>Account disclosures</li>
            <li>Fee schedules</li>
            <li>Transaction receipts</li>
            <li>Statements</li>
            <li>Tax documents</li>
            <li>Customer support communications</li>
            <li>Legal notices</li>
            <li>Amendments and updates</li>
            <li>Card-related disclosures and notices</li>
            <li>Regulatory disclosures required by law</li>
          </ul>
          <p>Communications may be delivered through:</p>
          <ul>
            <li>the STBL platform;</li>
            <li>email;</li>
            <li>in-app notifications;</li>
            <li>dashboard messages; or</li>
            <li>links to documents or disclosures.</li>
          </ul>
          <p>
            Electronic communications will have the same legal effect as
            communications provided in paper form.
          </p>

          <h3>2. Consent to Electronic Signatures</h3>
          <p>You agree that:</p>
          <ul>
            <li>
              your electronic acceptance, checkbox consent, typed name, or other
              electronic action constitutes your electronic signature;
            </li>
            <li>
              your electronic signature has the same legal effect as a handwritten
              signature; and
            </li>
            <li>
              electronic records satisfy any legal requirement that communications be
              provided in writing.
            </li>
          </ul>

          <h3>3. Paper Copies</h3>
          <p>
            You may request a paper copy of any electronic communication by
            contacting:{" "}
            <a href="mailto:support@stbl.io">support@stbl.io</a>
          </p>
          <p>
            STBL may charge a reasonable fee for providing paper copies where
            permitted by law.
          </p>

          <h3>4. Withdrawal of Consent</h3>
          <p>
            You may withdraw your consent to receive electronic communications at any
            time by contacting{" "}
            <a href="mailto:support@stbl.io">support@stbl.io</a>.
          </p>
          <p>However, withdrawing consent may result in:</p>
          <ul>
            <li>restricted access to STBL services;</li>
            <li>inability to use certain platform features; or</li>
            <li>
              closure of your account if electronic delivery is required for service
              operation or legal compliance.
            </li>
          </ul>
          <p>
            Any withdrawal of consent will not affect the legal validity of
            communications previously delivered electronically.
          </p>

          <h3>5. Updating Your Contact Information</h3>
          <p>
            You are responsible for maintaining accurate and current contact
            information, including:
          </p>
          <ul>
            <li>email address;</li>
            <li>phone number; and</li>
            <li>mailing address.</li>
          </ul>
          <p>
            You acknowledge that STBL is not responsible for communications not
            received due to outdated or incorrect contact information.
          </p>

          <h3>6. Hardware and Software Requirements</h3>
          <p>To access and retain electronic communications, you must have:</p>
          <ul>
            <li>a device capable of accessing the internet;</li>
            <li>a modern web browser;</li>
            <li>a valid email address;</li>
            <li>the ability to view PDF documents;</li>
            <li>sufficient storage space or printing capability.</li>
          </ul>
          <p>
            You acknowledge that you can access, review, download, and retain
            electronic communications provided by STBL.
          </p>

          <h3>7. Retention of Records</h3>
          <p>
            You should print or save copies of electronic communications for your
            records.
          </p>
          <p>
            STBL may, but is not obligated to, retain electronic communications for any
            specific period unless required by law.
          </p>

          <h3>8. Federal E-SIGN Act</h3>
          <p>
            You acknowledge and agree that this Consent is provided in connection with
            the U.S. Electronic Signatures in Global and National Commerce Act
            (&ldquo;E-SIGN Act&rdquo;) and any applicable state electronic transaction
            laws.
          </p>

          <h3>9. Consent and Acknowledgment</h3>
          <p>
            By selecting &ldquo;I Accept the E-Sign Consent,&rdquo; you acknowledge
            that:
          </p>
          <ul>
            <li>you have read and understand this Consent;</li>
            <li>you consent to receive communications electronically;</li>
            <li>you can access electronic records in the format provided; and</li>
            <li>
              your electronic acceptance constitutes a legally binding signature.
            </li>
          </ul>
        </section>
      </div>
    </LegalLayout>
  );
};

export default ESignConsent;
